import * as React from 'react';
import * as models from '@app/models';
import { Grid, TextField } from '@material-ui/core';
import { Field, Form, Formik, FormikProps } from 'formik';
import { injectIntl } from 'react-intl';
import CarrierLogoNameComponent from './carrier-logo-name.component';
import * as _ from 'lodash';
import { tierOverrideConfigSchema } from './carriers.schema';
import { CarriersEnum } from '@app/app.enum';
import UspsShipTierOverride from './usps-ship-tier-override';

const InitialTierOverrides: models.ITierOverrideConfigs = {
	USPSeVSWebtoolId: '',
	USPSeVSWebtoolPassword: '',
	USPSeVSWebtoolMID: '',
	MailOwner_MID: '',
};

const TierOverrideComponent: React.FunctionComponent<models.ITierOverrideProps> = React.forwardRef(
	(props, ref: React.MutableRefObject<any>) => {
		const formRef: React.MutableRefObject<Formik> = React.useRef(null);
		let formValues: models.ITierOverrideConfigs = null;

		React.useImperativeHandle(ref, () => ({
			getFormValues: async () => {
				try {
					await formRef.current.submitForm();
					const errors = Object.keys(formRef.current?.state.errors)?.length;
					if (!errors) {
						return formValues;
					}
					return null;
				} catch (err) {
					throw err;
				}
			},
		}));

		return (
			<Grid container={true} justifyContent='center' alignItems='center'>
				{props.selectedCarrierLogo && (
					<CarrierLogoNameComponent name={props.selectedCarrierName} logo={props.selectedCarrierLogo} />
				)}
				<Grid item={true} sm={12} className='mt-2'>
					<Formik
						initialValues={_.isEmpty(props.preloadedData) ? InitialTierOverrides : props.preloadedData}
						onSubmit={() => {}}
						validationSchema={tierOverrideConfigSchema(props.carrierCode)}
						enableReinitialize={true}
						ref={formRef}
					>
						{(formikProps: FormikProps<models.ITierOverrideConfigs>) => {
							// assigning form values to an outside variable
							formValues = formikProps.values as models.ITierOverrideConfigs;

							return (
								<Form noValidate={true} className='width-100'>
									<Grid container={true} justifyContent='flex-start' alignItems='center' spacing={2}>
										{props.carrierCode === CarriersEnum.USPSeVS && (
											<>
												<Grid item={true} sm={6} md={6} lg={6} xl={6}>
													<Field
														name='USPSeVSWebtoolId'
														label={props.intl.formatMessage({
															id: 'app.carrier-account.tier-override-USPSeVSWebtoolID-label',
														})}
														variant='outlined'
														component={TextField}
														type='text'
														fullWidth={true}
														value={formikProps.values.USPSeVSWebtoolId}
														onChange={(e: React.ChangeEvent) => formikProps.handleChange('USPSeVSWebtoolId')(e)}
														error={
															!!(
																(formikProps.values.USPSeVSWebtoolId?.length || formikProps.submitCount) &&
																!!formikProps.errors.USPSeVSWebtoolId
															)
														}
														helperText={
															formikProps.values.USPSeVSWebtoolId?.length || formikProps.submitCount
																? formikProps.errors.USPSeVSWebtoolId
																: null
														}
													/>
												</Grid>
												<Grid item={true} sm={6} md={6} lg={6} xl={6}>
													<Field
														name='USPSeVSWebtoolPassword'
														variant='outlined'
														label={props.intl.formatMessage({
															id: 'app.carrier-account.tier-override-USPSeVSWebtoolPassword-label',
														})}
														component={TextField}
														type='text'
														fullWidth={true}
														value={formikProps.values.USPSeVSWebtoolPassword}
														onChange={(e: React.ChangeEvent) => formikProps.handleChange('USPSeVSWebtoolPassword')(e)}
														error={
															!!(
																(formikProps.values.USPSeVSWebtoolPassword?.length || formikProps.submitCount) &&
																!!formikProps.errors.USPSeVSWebtoolPassword
															)
														}
														helperText={
															formikProps.values.USPSeVSWebtoolPassword?.length || formikProps.submitCount
																? formikProps.errors.USPSeVSWebtoolPassword
																: null
														}
													/>
												</Grid>
												<Grid item={true} sm={6} md={6} lg={6} xl={6}>
													<Field
														name='USPSeVSWebtoolMID'
														variant='outlined'
														label={props.intl.formatMessage({
															id: 'app.carrier-account.tier-override-USPSeVSWebtoolMID-label',
														})}
														component={TextField}
														type='text'
														fullWidth={true}
														value={formikProps.values.USPSeVSWebtoolMID}
														onChange={(e: React.ChangeEvent) => formikProps.handleChange('USPSeVSWebtoolMID')(e)}
														error={
															!!(
																(formikProps.values.USPSeVSWebtoolMID?.length || formikProps.submitCount) &&
																!!formikProps.errors.USPSeVSWebtoolMID
															)
														}
														helperText={
															formikProps.values.USPSeVSWebtoolMID?.length || formikProps.submitCount
																? formikProps.errors.USPSeVSWebtoolMID
																: null
														}
													/>
												</Grid>
                                                <Grid item={true} sm={6} md={6} lg={6} xl={6}>
                                                    <Field
                                                        name='MailOwner_MID'
                                                        variant='outlined'
                                                        label={props.intl.formatMessage({
                                                            id: 'app.carrier-account.tier-override-USPSMailOwnerMID-label',
                                                        })}
                                                        component={TextField}
                                                        type='text'
                                                        fullWidth={true}
                                                        value={formikProps.values.MailOwner_MID}
                                                        onChange={(e: React.ChangeEvent) => formikProps.handleChange('MailOwner_MID')(e)}
                                                        error={
                                                            !!(
                                                                (formikProps.values.MailOwner_MID?.length || formikProps.submitCount) &&
                                                                !!formikProps.errors.MailOwner_MID
                                                            )
                                                        }
                                                        helperText={
                                                            formikProps.values.MailOwner_MID?.length || formikProps.submitCount
                                                                ? formikProps.errors.MailOwner_MID
                                                                : null
                                                        }
                                                    />
										        </Grid>
											</>
										)}
										{props.carrierCode === CarriersEnum.USPSeVSNative && (
											<>
                                                <Grid item={true} sm={6} md={6} lg={6} xl={6}>
                                                    <Field
                                                        name='USPSeVSMID'
                                                        variant='outlined'
                                                        label={props.intl.formatMessage({
                                                            id: 'app.carrier-account.tier-override-USPSeVSMID-label',
                                                        })}
                                                        component={TextField}
                                                        type='text'
                                                        fullWidth={true}
                                                        value={formikProps.values.USPSeVSMID}
                                                        onChange={(e: React.ChangeEvent) => formikProps.handleChange('USPSeVSMID')(e)}
                                                        error={
                                                            !!(
                                                                (formikProps.values.USPSeVSMID?.length || formikProps.submitCount) &&
                                                                !!formikProps.errors.USPSeVSMID
                                                            )
                                                        }
                                                        helperText={
                                                            formikProps.values.USPSeVSMID?.length || formikProps.submitCount
                                                                ? formikProps.errors.USPSeVSMID
                                                                : null
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item={true} sm={6} md={6} lg={6} xl={6}>
                                                    <Field
                                                        name='MailOwner_MID'
                                                        variant='outlined'
                                                        label={props.intl.formatMessage({
                                                            id: 'app.carrier-account.tier-override-USPSMailOwnerMID-label',
                                                        })}
                                                        component={TextField}
                                                        type='text'
                                                        fullWidth={true}
                                                        value={formikProps.values.MailOwner_MID}
                                                        onChange={(e: React.ChangeEvent) => formikProps.handleChange('MailOwner_MID')(e)}
                                                        error={
                                                            !!(
                                                                (formikProps.values.MailOwner_MID?.length || formikProps.submitCount) &&
                                                                !!formikProps.errors.MailOwner_MID
                                                            )
                                                        }
                                                        helperText={
                                                            formikProps.values.MailOwner_MID?.length || formikProps.submitCount
                                                                ? formikProps.errors.MailOwner_MID
                                                                : null
                                                        }
                                                    />
                                                </Grid>
                                            </>  
										)}
										{(props.carrierCode === CarriersEnum.USPSePostage || props.carrierCode === CarriersEnum.USPSePostageNative) && (
											<>
                                                <Grid item={true} sm={6} md={6} lg={6} xl={6}>
                                                    <Field
                                                        name='MailOwner_MID'
                                                        variant='outlined'
                                                        label={props.intl.formatMessage({
                                                            id: 'app.carrier-account.tier-override-USPSMailOwnerMID-label',
                                                        })}
                                                        component={TextField}
                                                        type='text'
                                                        fullWidth={true}
                                                        value={formikProps.values.MailOwner_MID}
                                                        onChange={(e: React.ChangeEvent) => formikProps.handleChange('MailOwner_MID')(e)}
                                                        error={
                                                            !!(
                                                                (formikProps.values.MailOwner_MID?.length || formikProps.submitCount) &&
                                                                !!formikProps.errors.MailOwner_MID
                                                            )
                                                        }
                                                        helperText={
                                                            formikProps.values.MailOwner_MID?.length || formikProps.submitCount
                                                                ? formikProps.errors.MailOwner_MID
                                                                : null
                                                        }
                                                    />
                                                </Grid>
                                            </>  
										)}
                                        {props.carrierCode === CarriersEnum.USPSShip && (
											<UspsShipTierOverride 
                                                preloadedData={{ ...props.preloadedData}}
                                                selectedCarrierName={props.selectedCarrierName}
                                                selectedCarrierLogo={props.selectedCarrierLogo}
                                                carrierCode={props.carrierCode}
                                                formikProps={formikProps}
                                            />
										)}
									</Grid>
								</Form>
							);
						}}
					</Formik>
				</Grid>
			</Grid>
		);
	}
);

export default injectIntl(TierOverrideComponent, { withRef: true });



// WEBPACK FOOTER //
// ./src/components/carriers/tier-override.component.tsx